var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chart"},[_c('div',{staticClass:"chart-inner"},[_c('highcharts',{ref:"theme_3PieChart",attrs:{"options":_vm.theme_3PieChart}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }